import { helpers } from '@vuelidate/validators';

let length = 18;
const oldLength = 11;

export function phoneRulesDefault(oldPhone = false) {
    return {
        length: helpers.withMessage('Введите номер в формате +7(ххх)ххх-хх-хх', (value) => {
            if (!value) return true;
            return oldPhone ? value.length === oldLength || value.length === length : value.length === length;
        }),
    };
}
